import { IRestaurant } from '@rbi-ctg/store';
import { serviceModeList } from 'pages/cart/service-mode-details/service-mode-list';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useStoreAvailabilityFns } from './use-store-availability-fns';

interface IDefaultServiceModeOptions {
  restaurant: IRestaurant;
}

export function useDefaultServiceMode({ restaurant }: IDefaultServiceModeOptions) {
  const defaultServiceModeInStore = useFlag(LaunchDarklyFlag.DEFAULT_SERVICE_MODE_IN_STORE);
  const { getStoreServiceModeStatuses } = useStoreAvailabilityFns();
  const serviceModeStatuses = getStoreServiceModeStatuses(restaurant);

  // Get default service mode
  const defaultAvailableServiceMode = serviceModeStatuses.find(sms => {
    return (
      sms.serviceMode === defaultServiceModeInStore && sms.available && !sms.featureFlagDisabled
    );
  });

  // Determine the fallback service mode

  const fallbackServiceMode =
    serviceModeList.find(key => {
      const serviceModeStatus = serviceModeStatuses.find(sms => sms.serviceMode === key);
      return !!serviceModeStatus?.available && !serviceModeStatus.featureFlagDisabled;
    }) || serviceModeList[0];

  // Determine the initially resolved service mode
  return defaultAvailableServiceMode?.serviceMode || fallbackServiceMode;
}
